import { render, staticRenderFns } from "./LmLogMovements.vue?vue&type=template&id=385bf332&scoped=true"
import script from "./LmLogMovements.vue?vue&type=script&lang=js"
export * from "./LmLogMovements.vue?vue&type=script&lang=js"
import style0 from "./LmLogMovements.vue?vue&type=style&index=0&id=385bf332&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bf332",
  null
  
)

export default component.exports